import { render } from "./Vaucher.vue?vue&type=template&id=640ff2ae&scoped=true"
import script from "./Vaucher.vue?vue&type=script&lang=js"
export * from "./Vaucher.vue?vue&type=script&lang=js"

import "./Vaucher.vue?vue&type=style&index=0&id=640ff2ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640ff2ae"]])

export default __exports__